import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useGetCatalogoQuery, type Canal } from '../api';
import { useArgCatalogo } from './arg-catalogo';
import type { RootState } from '../store';
import { reprecificarItens, removerItem } from '../store/carrinho-slice';
import { reconciliarCarrinho, type AlteracaoPreco } from './reconciliar-carrinho';

export function useReconciliacaoCarrinho(canal: Canal): {
  alteracoes: AlteracaoPreco[];
  descartarAviso: () => void;
} {
  const dispatch = useDispatch();
  const { itens } = useSelector((s: RootState) => s.carrinho);
  const { data: catalogo } = useGetCatalogoQuery(useArgCatalogo(canal), { refetchOnMountOrArgChange: 30 });
  const [alteracoes, setAlteracoes] = useState<AlteracaoPreco[]>([]);
  const catalogoConciliado = useRef<typeof catalogo>(undefined);

  useEffect(() => {
    if (!catalogo || catalogo === catalogoConciliado.current || itens.length === 0) return;
    catalogoConciliado.current = catalogo;

    const resultado = reconciliarCarrinho(itens, catalogo);

    for (const removido of resultado.removidos) {
      dispatch(removerItem({ id: removido.id }));
    }

    if (resultado.itens !== itens) {
      dispatch(reprecificarItens({ itens: resultado.itens }));
    }

    if (resultado.alteracoes.length > 0) setAlteracoes(resultado.alteracoes);
  }, [catalogo, itens, dispatch]);

  return { alteracoes, descartarAviso: () => setAlteracoes([]) };
}
